// GoHighLevel webhook dispatcher.
// Posts a flat JSON payload to GHL. Errors are swallowed so the UI never
// fails — the page-level code keeps a localStorage copy as a safety net.

const WEBHOOK_URL =
  "https://services.leadconnectorhq.com/hooks/UVVzNKZUd1L69rCuLWF8/webhook-trigger/b2f219b9-d1bb-4d59-9887-33e98371ccee";

export async function sendToGHL(payload) {
  try {
    await fetch(WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      // GHL webhooks accept cross-origin POSTs; we don't read the response.
      mode: "cors",
      keepalive: true,
    });
    return true;
  } catch (err) {
    // Silent fallback — don't block the user's success flow.
    // eslint-disable-next-line no-console
    console.warn("GHL webhook failed:", err);
    return false;
  }
}
